import { MarkerClustererF } from '@react-google-maps/api';
import React, { useCallback } from 'react';

import PipeMarker from './PipeMarker';

import { getMarkerConfig } from '../../helper';

import ClusterIcon from '../../../../assets/pipemap/cluster.png';

const clusterStyles = {
  textColor: 'blue',
  textSize: 12,
  url: ClusterIcon,
  className: 'cluster-normal',
  height: 80,
  width: 80,
};

const clusterActionStyles = {
  ...clusterStyles,
  className: 'cluster-action',
};

const PipeCluster = ({ pipeData, onMarkerClick, zoom }) => {
  /**
   * This function is used to display action icon for clusters with markers that require attention.
   * - index 1 uses the first element in styles array passed to `MarkerClustererF`
   *
   *
   * @param {Array<any>} markers - Array of markers.
   * @returns {Object} - Object containing the cluster icon configuration.
   */
  const calculateClusterIcon = useCallback((markers) => {
    // TODO: Add the condition to check if the marker has an action later
    // const locationsToCheck = new Set([
    //   '22,84', // Format: "lat,lng"
    //   '23,85',
    // ]);

    // for (const marker of markers) {
    //   const { lat, lng } = marker.position.toJSON();
    //   if (locationsToCheck.has(`${lat},${lng}`))
    //     return { text: markers.length, index: 2, title: 'Action Required!!' };
    // }

    return { text: markers.length, index: 1 };
  }, []);

  return (
    <MarkerClustererF
      gridSize={zoom > 15 ? 1 : 40}
      minimumClusterSize={2}
      styles={[clusterStyles, clusterActionStyles]}
      clusterClass="pipe-cluster"
      calculator={calculateClusterIcon}
    >
      {(clusterer) =>
        pipeData?.map((pipe) => {
          const config = getMarkerConfig(pipe);
          return (
            <PipeMarker
              key={pipe.id}
              marker={pipe}
              clusterer={clusterer}
              icon={config?.icon}
              color={config?.label?.color}
              size={config?.size}
              status={config?.status}
              onClick={onMarkerClick}
            />
          );
        })
      }
    </MarkerClustererF>
  );
};

export default PipeCluster;
